import { FunctionComponent } from 'react';

interface FieldLabelProps {
  id: string;
  label: string;
  optional?: boolean;
}

const FieldLabel: FunctionComponent<FieldLabelProps> = ({ id, label, optional }) => {
  return (
    <label htmlFor={id} className="text-secondary-std block text-sm leading-6">
      {label} {optional ? <span className="ml-1">(optional)</span> : ''}
    </label>
  );
};

export default FieldLabel;
